module.exports = __webpack_public_path__ + "static/InputField_decimal-3707100a070c5021d1999c2ed62d1354.png";